<template>
  <QInput
    filled
    :label="label"
    :model-value="modelValue"
    square
  >
    <template #append>
      <QBtn
        color="primary"
        dense
        icon="file_copy"
        size="sm"
        @click="copyToClipboard(modelValue)"
      />
    </template>
  </QInput>
</template>

<script>
import useClipboard from "shared/composables/useClipboard";

export default {
  name: "CopyToClipboardInput",
  props: {
    modelValue: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: "",
    },
  },
  setup() {
    const { copyToClipboard } = useClipboard();

    return { copyToClipboard };
  },
};
</script>
